import React       from 'react';
import ReactDom    from 'react-dom';

import Utils       from 'utils';
// -------------------------------------------------------

class InputText extends React.Component {
  update() {
    this.props.update_ev.bind(this)(this.item.value);
  }
  
  render() {
    let data = this.props.data;
    
    let value = (data.default == '' || data.default == null ) ? '' : Utils.setDate(data.default, 'YYYY-MM-DD');
    
    return (
      <input className="text" type="date" ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={value} />
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputText;